import { GetStaticPaths, NextPage } from 'next'
import DefaultErrorPage from 'next/error'
import { useRef } from 'react'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { TextbookPageDetail } from 'web_core/assets/textbook'
import { ContentLayout } from '~/components/Layout/Content'
import { useTextbookPageProps } from '~/hooks/useTextbookPageProps'
import {
  TextbookPageParams,
  TextbookPageProps,
  getTextbookPageStaticPaths,
  getTextbookPageStaticProps,
} from '~/static_props/textbook'

export const getStaticPaths: GetStaticPaths<TextbookPageParams> = () => {
  return getTextbookPageStaticPaths(true)
}

export const getStaticProps = getTextbookPageStaticProps

const Page: NextPage<TextbookPageProps> = (staticProps) => {
  const {
    isNotFound,
    textbook,
    chapters,
    pages,
    currentPage,
    category,
    references,
    macros,
  } = useTextbookPageProps(staticProps)
  const contentRef = useRef<HTMLDivElement>(null)
  if (isNotFound) return <DefaultErrorPage statusCode={404} />
  return (
    <ContentLayout
      head={{
        title:
          currentPage && textbook
            ? `【${textbook.title}】${currentPage.title}`
            : '不明な参考書のページ',
        description: currentPage?.body,
      }}
      contentRef={contentRef}
      content={textbook}
      currentPage={currentPage}
      pages={pages}
      isNotFound={isNotFound}
    >
      {textbook &&
      pages &&
      chapters &&
      category &&
      currentPage &&
      macros &&
      references ? (
        <TextbookPageDetail
          className="mb-7 mt-5"
          textbook={textbook}
          contentRef={contentRef}
          currentPage={currentPage}
          pages={pages}
          category={category}
          chapters={chapters}
          references={references}
          macros={macros}
        />
      ) : (
        <LoadingSpinner />
      )}
    </ContentLayout>
  )
}

export default Page
